.weight {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
  align-items: flex-end;
  min-inline-size: 0;
}

.field {
  flex: 1 1 10rem;
}

.capture {
  flex: none;
}
